module.exports = __webpack_public_path__ + "img/new-template.70a17177.webp";